export const UPDATE_RATING_SUCCESS = 'UPDATE_RATING_SUCCESS';

export const updateRatingSuccess = results => ({
    type: UPDATE_RATING_SUCCESS,
    payload: { results },
});
